import React from "react";
import {useSelector} from "react-redux";
import {AddNotes} from "./addNotes";
import {ButtonMain} from "components";
import {isAdmin, useSecondaryModal} from "utils";
import {Svg} from "assets";
import {NoteCard} from "./noteCard";


export const Notes = ({legId, tripId}) => {
    const {singleTrip} = useSelector((state) => ({
        singleTrip: state.legs.singleTrip,
    }));

    const {openSecondary} = useSecondaryModal();
    const notes = singleTrip?.legs?.find((leg) => leg?.id === legId)?.notes


    const handleAddNote = () => {
        openSecondary(<AddNotes legId={legId} tripId={tripId}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 1276,
        });
    };


    return (
        <div className="notes-wrapper" style={{height: '100%'}}>
            <div className="modal-header-main space-between">
                <h2 className='modal-header-title'>Note</h2>

                {(isAdmin && !!notes?.length) &&
                    <ButtonMain
                        text="Add Note"
                        startIcon={<Svg.PlusSvg/>}
                        onClick={handleAddNote}
                        buttonMainStyles={{
                            height: "44px",
                            width: "fit-content",
                            padding: "10px 16px",
                        }}
                    />
                }
            </div>

            <div className='modal-body-main' style={{minHeight: '40vh'}}>
                {notes?.length ? (
                    <div className="notes-box">
                        {singleTrip?.legs?.find((leg) => leg?.id === legId)?.notes?.map((note) => (
                            <NoteCard
                                item={note}
                                legId={legId}
                                tripId={tripId}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="notes-empty-wrapper">
                        <div className="notes-empty-box">
                            <Svg.NotesEmptySvg/>

                            <p className="notes-empty-title">No notes available!</p>

                            {isAdmin &&
                                <p className="notes-empty-desc">
                                    You haven’t added any notes yet. Click{" "}
                                    <span style={{fontWeight: 600}}>“Add Note”</span> to get
                                    started.
                                </p>
                            }

                            {isAdmin &&
                                <ButtonMain
                                    text="Add Note"
                                    onClick={handleAddNote}
                                    small
                                    buttonMainStyles={{
                                        width: "fit-content",
                                        padding: "6px 12px",
                                    }}
                                />

                            }
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
